module.exports = __webpack_public_path__ + "static/img/person_2.a309145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/person_2.jpg
// module id = 6via
// module chunks = 1